module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mask-div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullImgActive),
      expression: "fullImgActive"
    }],
    attrs: {
      "auto": true
    },
    on: {
      "mask-click": _vm.closeMask
    }
  }, [_c('img', {
    staticClass: "full_img_display",
    attrs: {
      "src": _vm.src
    },
    on: {
      "click": _vm.closeMask
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c5e3184!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mask/FullImageDisplay.vue
// module id = 177
// module chunks = 1